<template>
  <v-container fluid>
    <PageHeaderSlot showBackButton />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card>
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="courseCategoryCode"
                placeholder="courseCategoryCode"
                :fieldValue.sync="formData.category_code"
                :required="gDisableEmptyCode"
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                label="courseCategoryName"
                placeholder="courseCategoryName"
                :fieldValue.sync="formData.name"
                required
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="campus"
                placeholder="selectCampus"
                :fieldValue.sync="formData.schools"
                :options="tutorSchoolOptions"
                required
                isMultiple
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3" v-if="!isAppMode(['T01'])">
              <CourseColorPicker
                label="defaultTimetableColor"
                placeholder="selectTimetableColor"
                :fieldValue.sync="formData.color"
                enableClear
                :dispatchUpdateOnChange="dispatchUpdateOnChange"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <div class="d-flex align-center mt-4">
        <FormButton @click="save()" />
        <FormButton
          v-if="$validate.DataValid(id)"
          class="ml-4"
          outlined
          color="error"
          text="delete"
          @click="handleDelete()"
        />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'
import CourseColorPicker from '@/components/CourseColorPicker.vue'

export default {
  name: 'CourseCategoryDetails',
  inject: ['getConfirmDialogRef'],
  components: {
    FormInput,
    FormSelect,
    CourseColorPicker,
  },
  computed: {
    confirmRef() {
      return this.getConfirmDialogRef()
    },
    id() {
      return this.$validate.regexNumber(this.$route.params.id) ? parseInt(this.$route.params.id) : null
    },
    dispatchUpdateOnChange() {
      return this.$validate.DataValid(this.id)
    },
    gradeOptions() {
      return this.$store.getters.gradeOptions
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    permissionValid: true,
    disableCourseGrade: false,
    formData: {
      category_code: '',
      name: '',
      schools: [],
      color: '',
    },
    initSchools: [],

    tutorSchoolOptions: [],
  }),
  methods: {
    async _getCourseCategoryById() {
      try {
        const data = await this.$Fetcher.GetCourseCategoryById(this.id)
        // staff只可以view所屬分校category
        if (this.$validate.DataValid(data.schools, true)) {
          let pass = false
          const getUserSchools = this.gfGetUserSchools()
          for (let i = 0; i < data.schools.length; i++) {
            if (getUserSchools.includes(data.schools[i])) {
              pass = true
              break
            }
          }
          if (!pass) {
            this.permissionValid = false
            throw 'message.notBelongCourseCategoryBranch'
          }
        }

        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
        this.initSchools = JSON.parse(JSON.stringify(data.schools))

        let isAllSchool = true
        for (let i = 0; i < this.tutorSchoolOptions.length; i++) {
          if (this.tutorSchoolOptions[i].value !== -1) {
            const found = this.formData.schools.find(el => el === this.tutorSchoolOptions[i].value)
            if (!found) {
              isAllSchool = false
              break
            }
          }
        }
        if (isAllSchool) {
          this.formData.schools.push(-1)
        }
      } catch (err) {
        this.$common.error(err)
        if (err !== 'abort') {
          this.showAlert({
            message: 'noData',
            returnLink: 'CourseCategoryList',
          })
        }
      } finally {
        this.$store.dispatch('toggleLoadingPage', false)
      }
    },
    async _getSetting() {
      let data = null
      if (this.gEnableCustomGrade) {
        try {
          data = await this.$Fetcher.GetSetting()
        } catch (err) {
          this.$common.error(err)
        }
      }
      this.disableCourseGrade = this.gfCheckDisabledCourseGrade(data)
    },
    async _getTutorSchoolOptions() {
      try {
        const { data } = await this.$Fetcher.GetSchools()
        const filtered = data.filter(el => el.active === true)
        if (this.$validate.DataValid(filtered)) {
          this.tutorSchoolOptions = filtered.map(el => {
            return { value: el.id, text: el.name }
          })

          let disabledAll = false
          const getUserSchools = this.gfGetUserSchools()
          if (this.$validate.DataValid(this.id)) {
            // when edit，不屬於staff的分校會disabled
            this.tutorSchoolOptions = this.tutorSchoolOptions.map(el => {
              const disabled = !getUserSchools.includes(el.value)
              if (disabled) {
                disabledAll = true
              }
              return {
                ...el,
                disabled: disabled,
              }
            })
          } else {
            // When create，只會攞staff所屬嘅分校
            this.tutorSchoolOptions = this.tutorSchoolOptions.filter(el => getUserSchools.includes(el.value))
          }

          this.tutorSchoolOptions.unshift({
            value: -1,
            text: this.$t('allCenters'),
            disabled: disabledAll,
          })
        }
      } catch (err) {
        this.$common.error(err)
      }
    },

    // -- (確認)
    async save() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }

      this.$store.dispatch('setLoading', true)
      const payload = {
        category_code: this.formData.category_code,
        name: this.formData.name,
        schools: this.formData.schools.filter(el => el !== -1),
        color: this.formData.color,
      }

      if (this.$validate.DataValid(this.id)) {
        try {
          await this.$Fetcher.UpdateCourseCategory(this.id, payload)

          if (this.gEnableAutoGenCourse) {
            // check 分校有冇update到，有就要update埋啲course
            let needUpdate = false
            if (payload['schools'].length !== this.initSchools.length) {
              needUpdate = true
            } else {
              for (let i = 0; i < this.initSchools.length; i++) {
                if (!payload['schools'].includes(this.initSchools[i])) {
                  needUpdate = true
                  break
                }
              }
            }
            if (needUpdate) {
              const courseIds = await this._getCoursesByCategory()
              if (courseIds.length > 0) {
                this._updateCourses(courseIds)
                return
              }
            }
          }

          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('setDataIsUpdated', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.saveSuccess',
            type: 'success',
            refresh: true,
          })
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        }
      } else {
        try {
          const data = await this.$Fetcher.NewCourseCategory(payload)

          let coursePayload = {
            schools: payload['schools'],
            category_id: data.id,
          }
          if (this.gEnableAutoGenCourse) {
            let grades = []
            if (!this.disableCourseGrade) {
              grades = this.gradeOptions
            }
            setTimeout(() => {
              this._createCourses(coursePayload, grades)
            }, 500)
          } else {
            this.$store.dispatch('setLoading', false)
            this.$store.dispatch('setDataIsUpdated', false)
            this.$store.dispatch('toggleSnack', {
              message: 'message.createSuccess',
              type: 'success',
              redirect: 'CourseCategoryList',
            })
          }
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
          })
        }
      }
    },
    /**
     * default create曬咁多級嘅course data
     * [disableCourseGrade] 一個category一個course data, empty grade
     */
    async _createCourses(payload, grades = [], count = 0) {
      let create = false
      if ((grades.length < 1 && count === 0) || count < grades.length) {
        create = true
      }
      if (create) {
        let _grade = ''
        if (grades.length > 0 && grades[grades.length - 1 - count]) {
          _grade = grades[grades.length - 1 - count]['value']
        }
        try {
          const p = {
            ...payload,
            grade: _grade,
          }
          await this.$Fetcher.NewCourse(p)
          count += 1
          this._createCourses(payload, grades, count)
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.createFail',
            message: err,
            isError: true,
            returnLink: 'CourseCategoryList',
          })
        }
      } else {
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.createSuccess',
          type: 'success',
          redirect: 'CourseCategoryList',
        })
      }
    },
    _getCoursesByCategory() {
      return new Promise(async (resolve, reject) => {
        try {
          let payload = {
            filter_item: [{ key: 'course_category_id', value: this.id }],
          }
          const { data } = await this.$Fetcher.GetCourses(payload)
          const courseIds = data.map(el => el.id)
          resolve(courseIds)
        } catch (err) {
          this.$common.error(err)
          resolve([])
        }
      })
    },
    async _updateCourses(courseIds, count = 0) {
      if (count < courseIds.length) {
        try {
          const p = {
            schools: this.formData.schools.filter(el => el !== -1),
          }
          await this.$Fetcher.UpdateCourse(courseIds[count], p)
          count += 1
          this._updateCourses(courseIds, count)
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.saveFail',
            message: err,
            isError: true,
          })
        }
      } else {
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      }
    },

    // -- (刪除)
    async handleDelete() {
      if (!this.permissionValid) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      const confirm = await this.confirmRef.show({ isDelete: true })
      if (confirm) {
        this.$store.dispatch('setLoading', true)

        try {
          const courseIds = await this.$Fetcher.DeleteCourseCategory(this.id, this.gEnableAutoGenCourse)
          if (this.$validate.DataValid(courseIds, true)) {
            this._deleteCourses(courseIds)
            return
          }
          this.$store.dispatch('setLoading', false)
          this.$store.dispatch('toggleSnack', {
            message: 'message.deleteSuccess',
            type: 'success',
            redirect: 'CourseCategoryList',
          })
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        }
      }
    },
    async _deleteCourses(courseIds, count = 0) {
      if (count < courseIds.length) {
        try {
          await this.$Fetcher.DeleteCourse(courseIds[count])
          count += 1
          this._deleteCourses(courseIds, count)
        } catch (err) {
          this.$common.error(err)
          this.$store.dispatch('setLoading', false)
          this.showAlert({
            title: 'message.deleteFail',
            message: err,
            isError: true,
          })
        }
      } else {
        this.$store.dispatch('setLoading', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.deleteSuccess',
          type: 'success',
          redirect: 'CourseCategoryList',
        })
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: CourseCategoryDetails')
      this.permissionValid = true
      this.userType = this.gfGetUserType()
      await this._getSetting()
      await this._getTutorSchoolOptions()
      if (this.$validate.DataValid(this.id)) {
        // edit
        this._getCourseCategoryById()
      } else {
        // new
        this.$store.dispatch('toggleLoadingPage', false)
        if (
          this.gEnableAutoGenCourse &&
          !this.disableCourseGrade &&
          this.gEnableCustomGrade &&
          this.gradeOptions.length < 1
        ) {
          const confirm = await this.confirmRef.show({
            message: 'message.noGradeGenCourse',
            cancelBtnText: 'navToCreateGrade',
            confirmBtnText: 'true',
          })
          if (!confirm) {
            this.$router.replace({ name: 'GradeSetting' })
          }
        }
      }
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
